/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Comment } from './comment';
import { TimespanString } from './timespanString';
import { NotificationDto } from './notificationDto';
import { TimespanDataPlan } from './timespanDataPlan';
import { DeviceMovebankInformationDto } from './deviceMovebankInformationDto';
import { ShareDto } from './shareDto';
import { TimespanLong } from './timespanLong';
import { TimespanNetworkStatus } from './timespanNetworkStatus';
import { ParameterData } from './parameterData';
import { GPSPosition } from './gPSPosition';
import { DeviceMetaInformationDto } from './deviceMetaInformationDto';
import { DataForwardingRuleDto } from './dataForwardingRuleDto';
import { Belt } from './belt';
import { CameraDto } from './cameraDto';
import { DeploymentDto } from './deploymentDto';
import { StringTimespan } from './stringTimespan';
import { Schedule } from './schedule';
import { TimespanComProvider } from './timespanComProvider';
import { CollarBuild } from './collarBuild';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CollarAdminDto { 
    idDevice?: number;
    id?: number;
    insertTs?: string;
    updateTs?: string;
    deviceTypeId?: string;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    parameterDataList?: Array<ParameterData>;
    warranty?: string;
    testDevice?: boolean;
    userSubsystemVisibility?: Array<boolean>;
    batteryTimeline?: Array<StringTimespan>;
    pcbTypeId?: string;
    gpsPlusDevice?: boolean;
    buildInProduction?: CollarBuild;
    currentBuild?: CollarBuild;
    previousBuilds?: Array<CollarBuild>;
    comments?: Array<Comment>;
    replacedById?: number;
    nfcTagUid?: string;
    replaces?: number;
    name?: string;
    shares?: Array<ShareDto>;
    orderName?: string;
    deviceManufacturingStatus?: CollarAdminDto.DeviceManufacturingStatusEnum;
    comType?: CollarAdminDto.ComTypeEnum;
    knownToSendBrokenMessages?: boolean;
    comIdTimeline?: Array<TimespanString>;
    comProviderTimeline?: Array<TimespanComProvider>;
    dataPlanTimeline?: Array<TimespanDataPlan>;
    networkStatusTimeline?: Array<TimespanNetworkStatus>;
    paymentAccountTimeline?: Array<TimespanLong>;
    airtimeNetworkStatusChangeRequested?: CollarAdminDto.AirtimeNetworkStatusChangeRequestedEnum;
    notifications?: Array<NotificationDto>;
    emailForwarding?: Array<DataForwardingRuleDto>;
    deviceMetaInformation?: DeviceMetaInformationDto;
    movebankInformation?: Array<DeviceMovebankInformationDto>;
    schedules?: Array<Schedule>;
    lastReceivedCommandTime?: string;
    commandCount?: number;
    belt?: Belt;
    internalDropOffId?: number;
    externalDropOffId?: number;
    internalDropOffRadioFiringParameterData?: string;
    externalDropOffRadioFiringParameterData?: string;
    vhfBeaconTransmitterId?: number;
    camera?: CameraDto;
    animalSpeciesId?: string;
    lastPosition?: GPSPosition;
    distanceLastPosition?: number;
    roofTestCompleted?: string;
    currentAnimalName?: string;
    deployments?: Array<DeploymentDto>;
    color?: string;
    lowBatteryStatus?: CollarAdminDto.LowBatteryStatusEnum;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
    _class: string;
}
export namespace CollarAdminDto {
    export const DeviceManufacturingStatusEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type DeviceManufacturingStatusEnum = typeof DeviceManufacturingStatusEnum[keyof typeof DeviceManufacturingStatusEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
    export const LowBatteryStatusEnum = {
        Alert: 'ALERT',
        Resolved: 'RESOLVED'
    } as const;
    export type LowBatteryStatusEnum = typeof LowBatteryStatusEnum[keyof typeof LowBatteryStatusEnum];
}


export type LowBatteryStatusEnum = typeof CollarAdminDto.LowBatteryStatusEnum[keyof typeof CollarAdminDto.LowBatteryStatusEnum];
